module.exports = __webpack_public_path__ + "static/media/CV - Yoni Sisso.6383a453.pdf";